import { render } from "./LabelContactForm.vue?vue&type=template&id=238cddcf"
import script from "./LabelContactForm.vue?vue&type=script&lang=js"
export * from "./LabelContactForm.vue?vue&type=script&lang=js"
script.render = render

export default script